/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { riskPolicyChallengesAcknowledge } from "../funcs/riskPolicyChallengesAcknowledge.js";
import { riskPolicyChallengesDecline } from "../funcs/riskPolicyChallengesDecline.js";
import { riskPolicyChallengesGet } from "../funcs/riskPolicyChallengesGet.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { AcknowledgeRiskPolicyChallengeResponseBody } from "../models/components/acknowledgeriskpolicychallengeresponsebody.js";
import { DeclineRiskPolicyChallengeResponseBody } from "../models/components/declineriskpolicychallengeresponsebody.js";
import { GetRiskPolicyChallengeResponseBody } from "../models/components/getriskpolicychallengeresponsebody.js";
import {
  AcknowledgeRiskPolicyChallengeRequest,
  AcknowledgeRiskPolicyChallengeSecurity,
} from "../models/operations/acknowledgeriskpolicychallenge.js";
import {
  DeclineRiskPolicyChallengeRequest,
  DeclineRiskPolicyChallengeSecurity,
} from "../models/operations/declineriskpolicychallenge.js";
import {
  GetRiskPolicyChallengeRequest,
  GetRiskPolicyChallengeSecurity,
} from "../models/operations/getriskpolicychallenge.js";
import { unwrapAsync } from "../types/fp.js";

export class PolicyChallenges extends ClientSDK {
  /**
   * acknowledgeRiskPolicyChallenge risk
   *
   * @remarks
   * Acknowledge a risk policy warn/challenge from a warning-link token. Records the acknowledgement so the user's retried action proceeds; self-service (no admin approval).
   */
  async acknowledge(
    request: AcknowledgeRiskPolicyChallengeRequest,
    security?: AcknowledgeRiskPolicyChallengeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AcknowledgeRiskPolicyChallengeResponseBody> {
    return unwrapAsync(riskPolicyChallengesAcknowledge(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * declineRiskPolicyChallenge risk
   *
   * @remarks
   * Decline a risk policy warn/challenge from a warning-link token: invalidate the link and mark the challenge declined. The blocked action stays blocked.
   */
  async decline(
    request: DeclineRiskPolicyChallengeRequest,
    security?: DeclineRiskPolicyChallengeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<DeclineRiskPolicyChallengeResponseBody> {
    return unwrapAsync(riskPolicyChallengesDecline(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getRiskPolicyChallenge risk
   *
   * @remarks
   * Fetch the details of a risk policy warn/challenge from a warning-link token, WITHOUT acknowledging it. Powers the approval page (shows what was flagged and Approve/Deny actions).
   */
  async get(
    request: GetRiskPolicyChallengeRequest,
    security?: GetRiskPolicyChallengeSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GetRiskPolicyChallengeResponseBody> {
    return unwrapAsync(riskPolicyChallengesGet(
      this,
      request,
      security,
      options,
    ));
  }
}
